<template>
  <qx-card-form title="车辆参数" v-show="showComponent" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <div slot="vehicleOrigin" slot-scope="prop" style="width: 240px;">
        <el-radio-group v-model="prop.form.vehicleOrigin">
          <el-radio
            :label="item.value"
            v-for="(item, index) in baseForm.vehicleOriginOpitons"
            :key="index"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="driveType">
        <qx-tips content="顺丰共建车队必须选择一个驱动形式，用于结算；其他车队视实际情况选择（可以不选）" />
      </span>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      showComponent: true,
      otherFormData: {
        vehicleOriginName: '',
        vehicleDataInfoExteId: '',
      },
      baseForm: {
        // 品牌名称
        brandModelOptions: [],
        vehicleOriginOpitons: [
          { label: '国产', value: '1' },
          { label: '进口', value: '2' },
        ],
        inline: true,
        form: [
          {
            label: '产地',
            value: 'vehicleOrigin',
            slot: true,
          },
          {
            label: '品牌名称',
            value: 'brandModel',
            type: 'select',
            default: '',
          },
          {
            label: '品牌型号',
            value: 'brandModel1',
            type: 'input',
          },
          {
            label: '车架号',
            value: 'vinNo',
            type: 'input',
            hide: false,
          },
          {
            label: '发动机号',
            value: 'engineNo',
            type: 'input',
            hide: false,
          },
          {
            label: '轴数',
            value: 'axleNumber',
            type: 'input',
            hide: false,
          },
          {
            label: '驱动形式',
            value: 'driveType',
            type: 'select',
            hide: false,
            options: [{
              label: '请选择', value: '-1',
            }, {
              label: '6*2', value: '0',
            }, {
              label: '6*4', value: '1',
            }, {
              label: '4*2', value: '2',
            }, {
              label: '6*2R', value: '3',
            }, {
              label: '8*4', value: '4',
            }],
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (brandModelOptions) {
      this.baseForm.brandModelOptions = brandModelOptions;
    },
    // 设置车辆参数（车架号和发动机号）
    async setVehicleParams (drivingLicenseInfo) {
      const formData = await this.$refs.baseForm.getVal();
      this.$refs.baseForm.setVal('form', Object.assign({}, formData, {
        vinNo: drivingLicenseInfo.vin,
        engineNo: drivingLicenseInfo.engineNo,
        brandModel1: drivingLicenseInfo.model,
      }));
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ext: {
            vehicleOrigin: formData.vehicleOrigin,
            brandModel: formData.brandModel1,
            axleNumber: formData.axleNumber,
            driveType: formData.driveType,
          },
          brandModel: formData.brandModel,
          vehicleDataInfoExteId: this.otherFormData.vehicleDataInfoExteId,
        };
      }

      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      formData = {
        ...formData,
        'ext.vehicleOrigin': formData.vehicleOrigin,
        'ext.brandModel': formData.brandModel1,
        'ext.vehicleDataInfoExteId': this.otherFormData.vehicleDataInfoExteId,
        'ext.axleNumber': formData.axleNumber,
        'ext.driveType': formData.driveType,
      };
      delete formData.ext;
      delete formData.brandModel1;
      // console.log('车辆参数提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 重置表单为初始状态
      this.resetBaseForm();

      let vehicleDataInfoExteId = '';
      if (data.ext) {
        if (data.ext.vehicleOrigin !== undefined) {
          data.vehicleOrigin = String(data.ext.vehicleOrigin);
        }
        if (data.ext.brandModel !== undefined) {
          data.brandModel1 = data.ext.brandModel;
        }
        if (data.ext.vehicleDataInfoExteId) {
          vehicleDataInfoExteId = data.ext.vehicleDataInfoExteId;
        }

        if (data.ext.axleNumber !== undefined) {
          data.axleNumber = String(data.ext.axleNumber || '');
        }
        if (data.ext.driveType !== undefined) {
          data.driveType = String(data.ext.driveType || -1);
        }
      } else {
        // 新建状态，默认选中国产
        data.vehicleOrigin = this.baseForm.vehicleOriginOpitons[0].value;
        data.vehicleOriginName = this.baseForm.vehicleOriginOpitons[0].label;
      }

      this.otherFormData = {
        vehicleOriginName: data.vehicleOriginName || '',
        vehicleDataInfoExteId: data.vehicleDataInfoExteId || vehicleDataInfoExteId || '',
      };

      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: this.$route.query.txjSwitch === '1',
        names: ['vinNo'],
      });
      this.$refs.baseForm.setVal(data);
    },
    // 修改车辆种类为【临时外调车时】
    changeToOutward () {
      // 切换成临时外调车
      this.setBaseForm('outward');
    },
    resetToNormal () {
      // 恢复成正常模式
      this.setBaseForm('my');
    },
    resetBaseForm () {
      if (this.$route.query.type === 'my') {
        this.setBaseForm('my');
        this.showComponent = true;
      } else {
        this.setBaseForm('outward');
        this.showComponent = false;
      }
    },
    setBaseForm (mode) {
      if (mode === 'my') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['vinNo', 'engineNo', 'axleNumber', 'driveType'],
        });
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
        });
      }
    },
    async formChange (vehicleInfo) {
      this.resetBaseForm();
      let parametersFormNames = ['vinNo', 'engineNo', 'axleNumber', 'driveType'];
      if (vehicleInfo) {
        // 隐藏不用填写的项
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: parametersFormNames,
        });
      }
    },
    receivedData (vehicleInfo) {
      if (this.$route.query.id) {
        // 修改状态，直接展示数据
      } else {
        // 新增状态，收到已注册可邀请变更表单
        this.formChange(vehicleInfo);
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
